// ---------------------------------------------------------------------------
// Serviços exibidos na seção "Serviços". Para adicionar, remover ou editar um
// card, basta alterar este array. O ícone deve ser um nome do lucide-react.
// ---------------------------------------------------------------------------
export const SERVICES = [
  {
    id: "avaliacao",
    icon: "ClipboardCheck",
    title: "Avaliação completa",
    description:
      "Consulta detalhada com exame clínico e planejamento personalizado para o seu sorriso.",
  },
  {
    id: "limpeza",
    icon: "Sparkles",
    title: "Limpeza e prevenção",
    description:
      "Profilaxia profissional, remoção de tártaro e orientações para manter a saúde bucal em dia.",
  },
  {
    id: "estetica",
    icon: "Gem",
    title: "Estética dental",
    description:
      "Facetas, lentes de contato dental e harmonização do sorriso com resultados naturais.",
  },
  {
    id: "clareamento",
    icon: "Sun",
    title: "Clareamento",
    description:
      "Clareamento seguro e supervisionado, em consultório ou caseiro, respeitando a sensibilidade.",
  },
  {
    id: "restauracoes",
    icon: "Layers",
    title: "Restaurações",
    description:
      "Restaurações em resina e cerâmica com estética e durabilidade, devolvendo função e conforto.",
  },
  {
    id: "implantes",
    icon: "Anchor",
    title: "Implantes e próteses",
    description:
      "Reabilitação oral com implantes e próteses planejadas para naturalidade e segurança.",
  },
];

// Motivos apresentados no formulário de solicitação
export const APPOINTMENT_REASONS = [
  ...SERVICES.map((s) => s.title),
  "Urgência / dor",
  "Outro",
];
